/**
 * <FieldItem />
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './FieldItem.scss';
import locale from './locale';
import FieldEditor from './FieldEditor';
import { sortable } from 'react-sortable';

const DragDots = (
<svg viewBox="0 0 32 32">
  <rect height="4" width="4" y="4" x="0" />
  <rect height="4" width="4" y="12" x="0" />
  <rect height="4" width="4" y="20" x="0" />
  <rect height="4" width="4" y="28" x="0" />
  <rect height="4" width="4" y="4" x="8" />
  <rect height="4" width="4" y="12" x="8" />
  <rect height="4" width="4" y="20" x="8" />
  <rect height="4" width="4" y="28" x="8" />
</svg>
)

class FieldItem extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {

    const {
      movable,
      editable,
      toggleEdit,
      onRemove,
      onChange,
      isEditing,
      index,
      options,
      type,
      label,
      required,
      isSortable,
      onMouseDownOnBars,
      onMouseUpOnBars,
      saveField
    } = this.props;

    return (
      <li className='field-item-wrapper' {...this.props}>
        <div className={classnames('field-item', { isSortable })}>
          { isSortable && <div className='dragHandle' onMouseDown={onMouseDownOnBars}>{DragDots}</div> }
          <span className='fieldLabelDisplay'>{label || __('New Field', locale)}</span>
          { required && <span className='required'> *</span>}
          { editable &&
            <span className='controller'>
              <i className='fa icon-cancel' onClick={onRemove}></i>
              <i className='fa icon-cog' onClick={toggleEdit}></i>
            </span>
          }
        </div>
        { isEditing &&
            <FieldEditor
              index={index}
              type={type}
              label={label}
              required={required}
              onChange={onChange}
              options={options}
              saveField={saveField}
            />}
        </li>
    )
  }
}

export default sortable(FieldItem);



// WEBPACK FOOTER //
// ./src/components/UI/CustomField/FieldItem.js